// Overhead
import React from 'react'
// import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import { withRouter } from "react-router-dom";
import $ from 'jquery'
import _get from 'lodash/get';
import _find from 'lodash/find';

// Components
import GlobalBanner from '../../components/globalBanner'
import LinnerDiv from '../../components/lineDiv'
import SubHeader from '../../components/subHeader'
import Note from '../../components/note'
import GuestPPLogInMini from '../../components/guestPPMiniLogIn'
import GuestPPLogIn from '../../components/guestPPLogIn'
import GuestSubmitButton from '../../components/guest-submit-button'
import AmountWrapper from '../../components/amountWrapper'
import GuestForm from '../guest/guestForm'
import PayCreditOrDebit from '../../components/payCreditOrDebit'
import RecurringCheckBox from '../../components/recurring-checkbox'
import CancelAndReturn from '../../components/cancelAndReturn'

// App Store/Flux
import AppStore from '../../stores/AppStore';
import AppDispatcher from '../../dispatcher/AppDispatcher'
import * as DonateAppActions from '../../actions/AppActions'

// Utility
import '../../utility/csrf'
import * as amountUtils from '../../components/amount/amountUtils';
import { handleLogIn, handleTokenReuse, addShake, validateDonationAmountForUS, updateDonation, handleGuestCountryChange } from '../../utility/helper'
import { isTeslaErrorMessage } from '../../utility/teslaUtility'
import * as FPT from '../../utility/fpt'
import templateData from '../../utility/getTemplateData'
import { localsMessages, guestLocalsMessages, isMobileHeaderExp } from '../../utility/getTemplateData'
import { formatAmount, normalizeNumber, formatCurrency } from '../../utility/formator'
import { guestPayment } from './helper'
import { DonateGiftAid } from 'guest-payment'
import { isAmountGreaterThanZero } from '../../components/amount/amountUtils';
import { loadProgressiveOnboarding } from '../../utility/lazyLoader';


let AppActions;
let SignupApp;
let Progressiveonboarding;

const messages = localsMessages('common/amount');
const errorMessages = localsMessages('routes/guest');
const allGuestMessages = guestLocalsMessages();
const initialData = JSON.parse(document.getElementById('initialData').innerHTML || {});
const senderDetails = initialData.senderDetails || {};
const prefillAddress = senderDetails.address || {};
const prefillPhone = senderDetails.phone || {};
let giftAidText = localsMessages('common/giftAidIt');
let giftAidTextObj = giftAidText && giftAidText.giftAidIt || {};
let { extraCost } = giftAidTextObj;
const donateGiftPercentage = AppStore.getGiftAidItExtraAmount();

class Guest extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			formattedAmount: this.getFormattedAmount(),
			hasLogo: templateData.hasLogo,
			subHeaderLabel: templateData.donationName,
			orgName: templateData.charityName,
			donationId: templateData.donationId,
			guestRedirectUrl: templateData.guestRedirectUrl,
			donateDisabled: false,
			showServiceErrors: false,
			errorMessages: [],
			recurringEnabled: templateData.recurringEnabled,
			recurringStatus: false,
			country: initialData.selectedCountry,
			selectedCountry: initialData.selectedCountry,
			charityCountry: templateData.charityCountry,
			memberMandatory: templateData.memberMandatory || false,
			accountCreationTriggered: false,

			recurringHelpText: '',
			recurringLabel: 'Make this a monthly donation',
			isProgressive: templateData.onboardingEnabled || false,
			isDonating: false,
			isShipping: templateData.isShipping || false,
			shareAddress: {},
			progressiveComponentLoaded: false,
			paymentProcessing: false
		};
	}

	getFormattedAmount = () => {
		const symbol = AppStore.getDonationSymbol() || '';
		const currency = AppStore.getDonationCode() || '';
		const amount = AppStore.getDonationAmount();
		let formattedAmount = '';
		if (amount) {
			formattedAmount = formatAmount({ currency, value: amount })
		}
		return formattedAmount
	}

	lazyLoadProgressiveComponent = () => {
		loadProgressiveOnboarding()
			.then((loadedModules) => {
				Progressiveonboarding = loadedModules[0];
				SignupApp = Progressiveonboarding.SignupApp;
				AppActions = Progressiveonboarding.AppActions;
				this.setState({
					progressiveComponentLoaded: true
				});
			})
	};

    componentDidMount() {
		this.toggleSpinner(this.state.isProgressive);
    	if (this.state.isProgressive) {
    		this.lazyLoadProgressiveComponent();
    	}

		// Only adding page name, if "fptPageName=landing", in other cases track event will be triggered when template is loaded.
		if (templateData.fptPageName === 'landing') {
			FPT.trackPage('main:donate:wps:guest:guestform', 'main:donate:wps:guest:guestform:web::')
		}

		// Checking for recurring status
		if (AppStore.getDonationRecurring() === 'checked') {
			this.setState({ recurringStatus: true })
		}

		// Checking token status
		handleTokenReuse();

		// Handles serverside errors
		this.dispatcherMessages = AppDispatcher.register((payload) => {
			 if (payload.action && (payload.action.actionType === 'UPDATE_SERVER_ERRORS')) {
				let errorMessages = payload.action.item.serverErrors
				let showServiceErrors = errorMessages.length > 0

				this.setState({ showServiceErrors, errorMessages });

				if (showServiceErrors) {
					let errorEl = $('.service_error_holder:visible')
					$('html, body').animate({ scrollTop: errorEl.offset() && errorEl.offset().top }, 1000);
				}
			 }

			 if (payload.action && (payload.action.actionType === 'CHANGE_AMOUNT')) {
				const { action: { item: { amount = 0 } = {} } = {} } = payload;
				this.updateAmount(amount);
			}

		});
	}

	getGiftAidExtraAmount(amount){
		const value = (donateGiftPercentage * normalizeNumber(amount)).toFixed(2);
		const currency = AppStore.getDonationCode();
		return formatCurrency({ value, currency })
	}

	updateGiftAidComponent = (state) => {
		let currency = AppStore.getDonationSymbol();
		let amount = AppStore.getDonationAmount() || 0;
		let extraCostText = extraCost;
		extraCostText = extraCostText && extraCostText.replace(/{currency}/g, currency);
		extraCostText = extraCostText && extraCostText.replace("{amount}", amount);
		extraCostText = extraCostText && extraCostText.replace("{extraAmount}", this.getGiftAidExtraAmount(amount));

		let modalp1 = giftAidTextObj && giftAidTextObj.modalp1 || '',
			modalp2 = giftAidTextObj && giftAidTextObj.modalp2 || '',
			applyGiftAid = giftAidTextObj && giftAidTextObj.applyGiftAid || '';

		modalp1 = modalp1 && modalp1.replace("{orgName}", state.subHeaderLabel);
		modalp2 = modalp2 && modalp2.replace("{orgName}", state.subHeaderLabel);
		applyGiftAid = applyGiftAid && applyGiftAid.replace("{orgName}", state.subHeaderLabel);

		giftAidTextObj.extraCost = extraCostText;
		giftAidTextObj.modalp1 = modalp1;
		giftAidTextObj.modalp2 = modalp2;
		giftAidTextObj.applyGiftAid = applyGiftAid;
	}

	componentWillUnmount() {
		AppDispatcher.unregister(this.dispatcherMessages);
	}

    /**********
	Calls dispatch on progressive redux store to add values to specific fields
	Also adds donor name to store, and determines to render the 'memberMandatory view
	**********/
    setInitialState = (store) => {
		if(store.getState().formFields.fieldState){
      store.dispatch({
          type: 'UPDATE_FIELD_STATES',
          value: [
            {paypalAccountData_address1:{value: prefillAddress.address1 || ''}},
            {paypalAccountData_address2:{value: prefillAddress.address2 || ''}},
            {paypalAccountData_city:{value: prefillAddress.city || ''}},
            {paypalAccountData_state:{value: prefillAddress.state || ''}},
			      {paypalAccountData_zip:{value: prefillAddress.zip || ''}},
            {paypalAccountData_firstName:{value: senderDetails.first_name || ''}},
            {paypalAccountData_lastName:{value: senderDetails.last_name || ''}},
            {paypalAccountData_email:{value: senderDetails.sender_email || ''}},
            {paypalAccountData_phone:{value: prefillPhone.phone_number || ''}},
            {paypalAccountData_memberMandatory:{value: this.state.memberMandatory|| false}},
            {paypalAccountData_shareAddress:{ visible: this.state.isShipping }}
          ]
        });
		}

		if(!store.getState().donorName) {
			store.dispatch({
				type: 'UPDATE_FORM_FIELD_STATES',
				value: [{donorName:templateData.donationName}]
			});
		}

		this.setState({ reduxStore: store, reduxStoreState: store.getState() });

        if(this.state.memberMandatory || AppStore.getDonationRecurring() === 'checked') {
          store.dispatch({
              type: 'UPDATE_FIELD_STATES',
              value: [
              {paypalAccountData_memberMandatory:{visible:false,value:true}},
              {password_TCPA_Fields_dynamicSection:true},
              {paypalAccountData_guestTermsAgree:{visible:false}},
              {paypalFormData_paragraphOne: {visible: false}},
              {paypalFormData_fieldGroupHeading: {visible: true}}]
          });
        }
    };

    /**********************
	UpdateReduxStore, passed to Progressive Component.
	Simply takes the state object from the store, and throws it in container state
	**********************/
    updateReduxStore = (store) => {
		const { appState: { appBusy, pageFlowData: { serviceData: { userAccountData = {} }  = {}, sessionStatus = {} } = {} } = {} } = store.getState();
		const {paypalAccountData_donateCountryselector = {}, paypalAccountData_shareAddress = {}} = store.getState().formFields.fieldState;

		const hasFormError = _get(store.getState(), 'formFields.hasFormError', {});
		const paypalAccountData = _get(store.getState(), 'appState.pageFlowData.errors.paypalAccountData', {});
		const cardData = _get(store.getState(), 'appState.pageFlowData.errors.cardData', {});
		const hasErrors = paypalAccountData.errorCode || cardData.errorCode || hasFormError ? true : false

		const isFullUser = sessionStatus.paypalAccount === 'exists';
		const isGuestUser = sessionStatus.guestAccount === 'exists';
		const isCardAdded = sessionStatus.card === 'exists';
		const paymentProcessing = this.state.paymentProcessing;

		/*
		* Need to presist value shareAddress checkbox
		* after completion of `/welcome/donate, redux store is reset and shareAddress checkbox value changes to false
		*/
		if (this.state.shareAddress !== paypalAccountData_shareAddress) {
			this.setState({ shareAddress: paypalAccountData_shareAddress});
		}

		this.setState({ isAppBusy: appBusy })
		this.toggleSpinner(appBusy);

		/*
		* ERROR CASE 1:- Guest full user add card failed
		* Full user account is created successfully
		* Card additon failed
		* Updating flux store with any card error
		* User is logged in
		* User will be redirected to /member
		* Member route will take care - to add new funding instrument
		*/
		if (isFullUser && !isCardAdded) {
			DonateAppActions.updateAddCardError('exists');
			return this.handleMemberFailure();
		}

		/*
		* Continue with donation
		* Account is created successfully
		* Card is added
		* User is logged in or not
		*
		* In-case of guest user - if not logged in - will try to get payeeId from mayFly
		* TODO: adding middleware - to accept unautorized guest user and make final attempt to login by getting payeeId from mayFly
		*/
		if ((isFullUser || isGuestUser) && !hasErrors && !paymentProcessing) {
			return this.processPayment();
		}
		/*
		*  for handling the country change based on the store value change for the country dropdown.
		*
		*/

		if(paypalAccountData_donateCountryselector && this.state.country !== paypalAccountData_donateCountryselector.value) {
			/*****
			The updateReduxStore() method is called every time an action is dispatched to the

			progressive store.
			That means the condition above is checked every time an action is dispatched.

			In the ProgressiveOnboarding component, there are two dispatches fired off in
			onChange() of the country drop down select field. That means the updateReduxStore() method
			is fired twice, and this check is made twice.

			this.setState() is asynchronous. Updating our state with this.setState() was two slow, and
			there isn't a way to make this.setState() synchronous. So, to avoid
			this.handleCountryChange() being fired twice(once for each dispatch), and sending two
			/donate/update/donation requests, we set the state directly, making it synchronous, and
			change this.state.country before the next updateReduxStore() is fired. When the second one is
			fired, this.state.country will have changed, and this.handleCountryChange will not fire again.

			Because we are not relying on this.state.country to trigger a re-render, and only using it
			for a condition to ultimately redirect the page, this is an appropriate departure from
			React's way of managing state.
			*****/

			this.state.country = paypalAccountData_donateCountryselector.value;
			this.handleCountryChange(paypalAccountData_donateCountryselector.value);
		}


		// log fpti errors and scroll to field level errors
		if (hasErrors && this.state.accountCreationTriggered && !appBusy) {
			if (cardData.errorCode) {
				FPT.trackError({ message: cardData.message, fieldId: 'global error', code: cardData.errorCode })
			}

			if (paypalAccountData.errorCode) {
				FPT.trackError({ message: paypalAccountData.message, fieldId: 'global error', code: paypalAccountData.errorCode })
			}
			this.state.accountCreationTriggered = false;

			this.setState({ accountCreationTriggered: false }, () => { this.handleScrollToError() })

		}

		this.updateErrorMessages(cardData, paypalAccountData);
	};

	/**
	 * Handle Country Change - Passed to Progressive component
	 * Gets new props for new country. If country is not allowed for a guest,
	 * it will redirect to legacy
	 *
	 * Note: Duplicate method is guestForm.js
	 */
    handleCountryChange = (country) => {
		let { charityCountry } = this.state;

		if (country !== initialData.selectedCountry) {
			DonateAppActions.changeCountry({ country: country });
			this.setState({ country: country });
			// Beacons for country change
			FPT.trackLinkClickWithData('changeCountry', { country: country });

			let { token, signUp = false } = templateData;
			let url = signUp ?
				`/donate?token=${token}&signup=true&country.x=${country}&locale.x=${country}` :
				`/donate?token=${token}&country.x=${country}&locale.x=${country}&countryChange=true&clientState=/donate/guest?token=${token}`;

			this.toggleSpinner(true);
			handleGuestCountryChange(url);
		}
	};

    getFPTDATA = () => {
		return {
			amount: AppStore.getDonationAmount(),
			code: AppStore.getDonationCode(),
			symbol: AppStore.getDonationSymbol()
		}
	};

    updateConversionSataus = (status = false) => {
		this.setState({ donateDisabled: status });
	};

    handleLogIn = (event) => {
		event.preventDefault();

		if (AppStore.getDonationAmount()) {
			FPT.trackLinkClickWithData('guestLogIn', {
				amount: AppStore.getDonationAmount(),
				code: AppStore.getDonationCode(),
				symbol: AppStore.getDonationSymbol()
			})
		}

		// Proceed to Login only if the donation amount is valid
		if (this.validateDonationAmount()) {
			handleLogIn();
		}
	};

    /**
	 * Display validation error
	 */
    displayValidationError = () => {
		const errorMessage = amountUtils.getMinimumDonationErrorMessage(messages);
		this.setState({
			showValidationError: true,
			validationErrorMessage: errorMessage
		});
		addShake();
	};

    hideValidationError = () => {
		this.setState({ showValidationError: false })
	};

    /**
	 * Validates donation amount and displays the validation error if any
	 */
    validateDonationAmount = () => {
		if (validateDonationAmountForUS()) {
			this.setState({ showValidationError: false, validationErrorMessage: '' });
			return true;
		}
		this.displayValidationError();
		return false;
	};

    handleRecurringChange = (status = false) => {
		this.setState({ recurringStatus: status });
		if (!this.state.memberMandatory && this.state.isProgressive) {
      this.state.reduxStore.dispatch({
          type: 'UPDATE_FIELD_STATES',
          value: [
          {paypalAccountData_memberMandatory:{visible:!status,value:status}},
          {password_TCPA_Fields_dynamicSection:status},
          {paypalAccountData_guestTermsAgree:{visible:!status}},
          {paypalFormData_paragraphOne: {visible: !status}},
          {paypalFormData_fieldGroupHeading: {visible: status}}
          ]
      });
		}
	};

    /**
	 * Clear the validation error onFocus
	 */
    handleAmountFocus = () => {
		if (this.state.showValidationError) {
			this.hideValidationError();
		}
	};

    /**
	 * Appends error messages from onboarding redux store
	 * to react's errorMessage state
	 *
	 * @author: mdemers
	 * @param {Object} cardData The cardData error object from redux store
	 * @param {Object} paypalAccountData The paypalAccountData error object from redux store
	 */
	updateErrorMessages = (cardData, paypalAccountData) => {
		const errorMessages = this.state.errorMessages;

		if (cardData.errorCode) {
			if (isTeslaErrorMessage(cardData.errorCode)) {
				if (!_find(errorMessages, { value: cardData.message })) {
					errorMessages.push({ value: cardData.message })
				}
			} else {
				this.handlePaymentFailure()
			}
		}

		if (paypalAccountData.errorCode) {
			if (isTeslaErrorMessage(paypalAccountData.errorCode)) {
				if (!_find(errorMessages, { value: paypalAccountData.message })) {
				errorMessages.push({ value: paypalAccountData.message })
				}
			} else {
				this.handlePaymentFailure()
			}
		}

		const showServiceErrors = this.state.errorMessages.length > 0 ? true : false

		this.setState({
			errorMessages: errorMessages,
			showServiceErrors: showServiceErrors
		})
	};

    // handles scrolling screen to the error
    handleScrollToError = () => {
		let errorEl = $('.vx_has-error-with-message:visible, .service_error_holder:visible')
		$('html, body').animate({ scrollTop: errorEl.offset() && errorEl.offset().top }, 1000);
		return
	};

    /*
	* showing and hiding spinner
	*/
    toggleSpinner = (isSpinner = false) => {
		if (this.state.isDonating) {
			return;
		}
		if (isSpinner) {
			$('.spinneroverlay').show();
		} else {
			$('.spinneroverlay').hide();
		}
	};

    /*
	* updateShareAddress
	* setting value of shareAddress checkbox before onboarding dispatched any event
	* shareAddress checkbox value is used by planning
	*/
    updateShareAddress = () => {
		DonateAppActions.updateShareAddress( this.state.shareAddress.value );
	};

    /*
	* triggerAccountCreation
	*/
    triggerAccountCreation = (event) => {
    	event.preventDefault();

    	if (!this.validateDonationAmount()) {
			$('html, body').animate({ scrollTop: $('.money_input').offset().top	}, 1000);
			addShake()
			return; // block account creation
		}

		if (!isAmountGreaterThanZero(AppStore.getDonationAmount())) {
			addShake()
			$('html, body').animate({ scrollTop: $('.money_input').offset().top	}, 1000);
			return; // block account creation
		}

    	const fieldId = event.target.id || event.target.name || event.target.innerText || event.target.href;
    	this.state.accountCreationTriggered = true;
		this.setState({ errorMessages: [] });
		this.updateShareAddress();
		this.state.reduxStore.dispatch(AppActions.submitFormAjax('/appData/action', 'submit_account_create', [{key: '/paypalAccountData/createUpdateReady', value: true}, {key: '/cardData/createUpdateReady', value: true}], fieldId))
	};

    /*
	* processDonation
	*/
	processPayment = (params = {}) => {
		this.setState({ paymentProcessing: true })
		if (this.state.isDonating) {
			return;
		}

		// Will be removed when onboarding component will return status using callback
		// Using isDonating to block duplicate call - need to synchronous
		this.state.isDonating = true;
		guestPayment(params).then((response = {}) => {
			this.setState({ isDonating: false })

			if (response.code === 'CROSS_BORDER' && response.fundingOpts) {
				const fundingOptions = response.fundingOpts[0];

				// Updating store with funding options and redirecting to review page
				DonateAppActions.updateFundingOptions({ fundingOptions })
				this.setState({ isDonating: false })
				return this.props.history.push('/donate/guest/crossborder');
			} else if (response.error &&
				response.error.auth_state === 'LOGGEDIN') {
				return this.handleMemberFailure();
			} else if (response.confirmation) {
				DonateAppActions.updateConfirmation({ confirmation: response.confirmationData });
				return this.handlePaymentSuccess(response);
			} else {
				return this.handlePaymentFailure(err);
			}
		}).catch((err)=>{
			console.log('processDonation err :: ', err);
			this.setState({ isDonating: false })
			return this.handlePaymentFailure(err);
		})
	};

    /*
	* handlePaymentSuccess
	*/
    handlePaymentSuccess = (response) => {
		if (response.isOfacPending) {
			return this.props.history.push('/donate/guest/pending')
		} else {
			return this.props.history.push('/donate/guest/confirmation');
		}
	};

    /*
	* handlePaymentFailure
	*/
    handlePaymentFailure = (response) => {
		return this.props.history.push('/donate/error/payment');
	};

    /*
	* handleMemberFailure
	* Redirect all member failure to donate/member
	* Known case
	* Case 1 :- WSM_PAYER_FUNDING_INSTRUMENTS_UNAVAILABLE
	* Case 2 :- WSM_VALIDATION_ERROR
	*/
    handleMemberFailure = () => {
		if (this.state.isDonating) {
			return;
		}
		// Will be removed when onboarding component will return status using callback
		// Using isDonating to block duplicate call - need to synchronous
		this.state.isDonating = true;
		updateDonation(`/donate/member?token=${templateData.token}`);
	};

	updateAmount(amount){
		const currency = AppStore.getDonationCode() || '';
		this.setState({ formattedAmount: formatAmount({ currency, value: amount }) });
	};

	handleGiftAidOption(giftAidState) {
		DonateAppActions.updateGiftaidItFlag({ giftAidItFlag: giftAidState });
	};

	/**
	* Should show note when charityNote is enabled and recurring is disabled
	* @return {Boolean} true to show note field
	*/
    shouldShowNote = () => {
		return templateData.charityNoteEnabled && !this.state.recurringStatus;
	};

	renderProgressive = () => {
		const progressiveOnboardingProps = {
			updateReduxStore: this.updateReduxStore,
			modelData: {},
			token: templateData.token,
			setInitialState: this.setInitialState,
			endpoint: `/welcome/donate?country.x=${templateData.country}&locale.x=${templateData.language}_${templateData.country}`,
      		griffinData: true
		}

		return (
			<div className="donate_onboarding_guest_form">
				<SignupApp {...progressiveOnboardingProps} />
				<GuestSubmitButton
					amount={this.state.formattedAmount}
					labels={allGuestMessages.guestLabels}
					isRecurring={this.state.recurringStatus}
					// disabled={this.props.donateDisabled}
					handleClick={this.triggerAccountCreation}
					// passwordFieldsOpen={this.state.passwordFieldsOpen}
				/>
				<CancelAndReturn />
			</div>
		)
	}

    render() {
		const errorgeneric = errorMessages.error && errorMessages.error.generic || '';
		const recurringStatus = AppStore.getDonationRecurring() === 'checked';
		const showServiceErrors = this.state.errorMessages && this.state.errorMessages.length > 0;
		const showProgressiveComponent = this.state.isProgressive && this.state.progressiveComponentLoaded;

		this.updateGiftAidComponent(this.state);

		return (
			<div className={`donate_wrapper ${isMobileHeaderExp() ? 'mobile_view' : ''}`}>
				<div className="container">
					{showServiceErrors ?
						<div className="col-xs-12 col-sm-12 col-md-12 service_error_holder">
							{this.state.errorMessages.map(function(message) {
								return <div className="row" key={message.key}>
											<p className="col-xs-1 col-sm-1 col-md-1"><span className="icon icon-small icon-critical-small" aria-hidden="true"></span></p>
											<p className="col-xs-11 col-sm-11 col-md-11 error-text"style={{ paddingLeft: '5px', marginTop: '5px' }}>{message.value}</p>
								</div>;
							})}
						</div> : null}
					<GlobalBanner
						logourl={this.state.logourl}/>
					<SubHeader
						donationId={this.state.donationId}
						orgName={this.state.orgName}
						label={this.state.subHeaderLabel}/>
					<form id="guestForm" className="donate_guest_form" noValidate>
						<AmountWrapper
							conversionStatus={this.updateConversionSataus}
							validateDonationAmount={this.validateDonationAmount}
							showValidationError={this.state.showValidationError}
							hideValidationError={this.hideValidationError}
							validationErrorMessage={this.state.validationErrorMessage}
							onFocus={this.handleAmountFocus}
						/>
						<p className="err_update_amount text-center">{errorgeneric}</p>
						{this.state.recurringEnabled &&
							<RecurringCheckBox
								toolTipText={this.state.recurringHelpText}
								label={this.state.recurringLabel}
								status={this.state.recurringStatus}
								handleChange={this.handleRecurringChange}
								hasRecurringHelp={false}
								showNote={true}
							/>
						}

						{templateData.isGiftaiditEnabled && <DonateGiftAid
													isAlreadyEnrolled={false}
													showAddress={false}
													addressData=''
													isChecked={false}
													handleGiftAidOption={this.handleGiftAidOption}
													contentMsg={giftAidTextObj}/>
						}
						<LinnerDiv />
						{this.shouldShowNote() ? <Note /> : null}
						<GuestPPLogIn handleLogIn={this.handleLogIn}/>
						<PayCreditOrDebit />

						{!this.state.isProgressive &&
							<div className="donate_guest_form">
								<GuestForm
									recurringStatus={recurringStatus}
									donateDisabled={this.state.donateDisabled}
									validateDonationAmountForUS={this.validateDonationAmount}
								/>
							</div>
						}
					</form>
					{showProgressiveComponent && this.renderProgressive()}
				</div>
			</div>
		)
	}
}
export default withRouter(Guest);


// WEBPACK FOOTER //
// ./pages/guest/guest.js